'use strict';

(function ($) {
  // Smooth scrolling using jQuery easing
  $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname
      .replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash)
      target = target.length
        ? target
        : $('[name=' + this.hash.slice(1) + ']')
      if (target.length) {
        $('html, body').animate({
          scrollTop: (target.offset().top - 48)
        }, 1000, 'easeInOutExpo')
        return false
      }
    }
  })
  // Closes responsive menu when a scroll trigger link is clicked
  $('.js-scroll-trigger').click(function () {
    $('.navbar-collapse').collapse('hide')
  })

  // Collapse the navbar when page is scrolled
  $(window).scroll(function () {
    if (!$('#mainNav').offset()) {

    } else if ($('#mainNav').offset().top > 100) {
      $('#mainNav').addClass('navbar-shrink')
    } else {
      $('#mainNav').removeClass('navbar-shrink')
    }
  })
})(jQuery)



// WEBPACK FOOTER //
// ./src/assets/js/creative.js